/* eslint-disable */
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from "recharts"
import {
  Box,
  Typography,
  Divider,
  Card,
} from '@mui/material';
import { useAppSelector } from '../../../store/hooks';
import { generateColorFromString } from "../../../utils/generateRandomColor";


const UserStatsCard = () => {
  const userStats = useAppSelector(state => state.whiltelabelSlice.userStats)
  return (
    <Card
      sx={{
        p: 4, borderRadius: 3, width: '100%', height: '100%'
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: 15,
          textTransform: "uppercase",
          letterSpacing: 0.1,
          mb: 1,
        }}
      >
        User Base & Tiers
      </Typography>

      <Box sx={{ display: "flex", gap: 4, alignItems: "flex-start", justifyContent: 'space-between' }}>
        <Box>
          <Typography sx={{ fontSize: 32, fontWeight: 700, mb: 1 }}>{userStats.totalUsers}</Typography>
          <Typography sx={{ fontSize: 13, mb: 2 }}>Total Users</Typography>
          <Divider sx={{ my: 1 }} />
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography sx={{ fontSize: 11, color: "#4a5568" }}>New Users This Month :</Typography>
            <Typography sx={{ fontSize: 11, fontWeight: 600 }}>{userStats.newUsersThisMonth}</Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography sx={{ fontSize: 11, color: "#4a5568" }}>Unsubscribed Users :</Typography>
            <Typography sx={{ fontSize: 11, fontWeight: 600 }}>{userStats.unSubscribedUsers}</Typography>
          </Box>
        </Box>
        <ResponsiveContainer width="40%" height={180}>
          <PieChart>
            <Pie data={userStats.data} cx="50%" cy="50%" innerRadius={50} outerRadius={80} dataKey="value">
              {userStats.data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={generateColorFromString(entry.name)} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </Box>
    </Card>
  )
}

export default UserStatsCard;